import type { Graph } from './graph';
import { enPack } from './kin/en';
import { relate } from './kin/relate';
import type { KinPack } from './kin/types';

export { labelFor } from './kin/en';
export type { Via } from './kin/types';

/**
 * Relationship label of `personId` as seen by `meId`, in the given word set (English by default).
 * Returns '' when the two are not connected at all.
 */
export function kinship(g: Graph, meId: string, personId: string, pack: KinPack = enPack): string {
  return pack.label(relate(g, meId, personId));
}
